import { SvgIcon, SxProps } from "@mui/material";
import ImagesSvg from "jsx:../../../Images/Icons/FontAwesome/solid/images.svg";

export function ImagesIcon(props: SxProps) {
    return <SvgIcon component={ImagesSvg} inheritViewBox sx={props} />;
}
